import _extends from "@babel/runtime/helpers/extends";
import React, { lazy } from 'react';
import { useState } from 'react';
import { useIntl, defineMessages, FormattedMessage } from 'react-intl-next';
import { useAuth } from './useAuth';
const AKModalDialog = /*#__PURE__*/lazy(() => import('@atlaskit/modal-dialog'));
const AKModalTransition = /*#__PURE__*/lazy(() => import('@atlaskit/modal-dialog').then(module => ({
  default: module.ModalTransition
})));
const AKModalHeader = /*#__PURE__*/lazy(() => import('@atlaskit/modal-dialog/modal-header'));
const AKModalTitle = /*#__PURE__*/lazy(() => import('@atlaskit/modal-dialog/modal-title'));
const AKModalBody = /*#__PURE__*/lazy(() => import('@atlaskit/modal-dialog/modal-body'));
const AKModalFooter = /*#__PURE__*/lazy(() => import('@atlaskit/modal-dialog/modal-footer'));
const AKButton = /*#__PURE__*/lazy(() => import('@atlaskit/button/loading-button'));
const SectionMessage = /*#__PURE__*/lazy(() => import('@atlaskit/section-message'));
const ModalThreeLOPrompt = ({
  onClose = () => {},
  isBlanketHidden,
  ...props
}) => {
  const {
    loading,
    startAuth,
    promptMessage,
    buttonText
  } = useAuth(props);
  const {
    authUrl
  } = props;
  const isAuthUrlEmpty = !authUrl || authUrl === '';
  const intl = useIntl();
  const {
    modalTitle,
    modalBody
  } = isAuthUrlEmpty ? {
    modalTitle: intl.formatMessage(messages.modalErrorTitle),
    modalBody: /*#__PURE__*/React.createElement(SectionMessage, {
      appearance: "error"
    }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(FormattedMessage, messages.noAuthURLErrorMessage)))
  } : {
    modalTitle: intl.formatMessage(messages.modalAccessRequiredTitle),
    modalBody: promptMessage
  };
  const [isModalOpen, setIsModalOpen] = useState(true);
  return /*#__PURE__*/React.createElement(AKModalTransition, null, isModalOpen && /*#__PURE__*/React.createElement(AKModalDialog, {
    onClose: () => {
      setIsModalOpen(false);
      onClose();
    },
    isBlanketHidden: isBlanketHidden
  }, /*#__PURE__*/React.createElement(AKModalHeader, null, /*#__PURE__*/React.createElement(AKModalTitle, null, modalTitle)), /*#__PURE__*/React.createElement(AKModalBody, null, modalBody), /*#__PURE__*/React.createElement(AKModalFooter, null, /*#__PURE__*/React.createElement(AKButton, {
    appearance: "subtle",
    onClick: () => {
      setIsModalOpen(false);
      onClose();
    }
  }, "Cancel"), !isAuthUrlEmpty && /*#__PURE__*/React.createElement(AKButton, {
    appearance: "primary",
    autoFocus: true,
    isLoading: loading,
    onClick: startAuth
  }, buttonText))));
};
export default ModalThreeLOPrompt;
export const makeModalThreeLOPrompt = ({
  onClose,
  appName
}) => {
  return function modalThreeLOPrompt({
    forgeDoc: {
      props
    },
    dispatch
  }) {
    const {
      message,
      authUrl,
      promptText
    } = props;
    return /*#__PURE__*/React.createElement(ModalThreeLOPrompt, {
      message: message,
      authUrl: authUrl,
      promptText: promptText,
      onSuccess: () => dispatch({
        type: 'render',
        extensionData: {}
      }),
      appName: appName,
      onClose: onClose
    });
  };
};
export const makeModalThreeLOPromptForCustomUI = ({
  onClose,
  appName,
  isBlanketHidden = false
}) => {
  return props => {
    return /*#__PURE__*/React.createElement(ModalThreeLOPrompt, _extends({}, props, {
      appName: appName,
      onClose: onClose,
      isBlanketHidden: isBlanketHidden
    }));
  };
};
const messages = defineMessages({
  noAuthURLErrorMessage: {
    id: 'confluence.threeLOPrompt.modal.no.authURL.error-message',
    defaultMessage: 'Consent URL not found. Please refresh the page and try again.',
    description: 'This text is displayed when the URL that gives an app certain permissions is not present.'
  },
  modalErrorTitle: {
    id: 'confluence.threeLOPrompt.modal.error.title',
    defaultMessage: 'Error',
    description: 'This is the title assigned to a modal when there is an error with this component'
  },
  modalAccessRequiredTitle: {
    id: 'confluence.threeLOPrompt.modal.access.required.title',
    defaultMessage: 'Access required',
    description: "This is the title assigned to a modal when access to the user's account is required."
  }
});